var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-pagination',{staticClass:"my-4",attrs:{"length":_vm.totalPage,"total-visible":7,"v-bind:click":_vm.changePage(_vm.currPage)},model:{value:(_vm.currPage),callback:function ($$v) {_vm.currPage=$$v},expression:"currPage"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }